import React from "react";

const cleanPercentage = (percentage: any): number => {
  const num = parseFloat(percentage);
  if (isNaN(num) || num < 0) return 0;
  if (num > 100) return 100;
  return num;
};

const Circle = ({ color, pct }: { color: string; pct?: number }) => {
  const r = 16;
  const circ = 2 * Math.PI * r;
  const strokePct = pct ? ((100 - pct) * circ) / 100 : undefined;
  return (
    <circle
      className={`${pct && pct < 20 ? "blink" : ""}`}
      r={r}
      cx={22}
      cy={20}
      fill="transparent"
      stroke={strokePct !== circ ? color : ""} // remove colour as 0% sets full circumference
      strokeWidth={"7px"}
      strokeDasharray={circ}
      strokeDashoffset={pct ? strokePct : 0}
      strokeLinecap="round"
    ></circle>
  );
};

const Pie = ({ percentageFull }) => {
  const pctRemaining = 100 - cleanPercentage(percentageFull);
  const color =
    pctRemaining > 50 ? "#188038" : pctRemaining > 30 ? "#FFA500" : "#FF0000";

  return (
    <svg width={42} height={42}>
      <g transform={`rotate(-90 ${"22 20"})`}>
        <Circle color="#E5E7EB" />
        <Circle color={color} pct={pctRemaining} />
      </g>
    </svg>
  );
};

export default Pie;
